import React, { forwardRef } from "react";
import { Checkbox, CheckboxProps } from "antd";

const VLCheckBox = forwardRef<any, CheckboxProps>((props, ref) => {
  const { ...restProps } = props;

  return <Checkbox {...restProps} ref={ref} />;
});

export default VLCheckBox;
